module.exports = __webpack_public_path__ + "static/4BHK-08-Bedroom-04-ca3ae50571aabb35c0230dd4601c4c8e.jpg";